/* -------------------------------------------------------------------------- */
/* ---------------------------------- FRONT --------------------------------- */

// CSS
import "../public/fonts/polysans.scss";
import "./scss/theme.scss";

// JS
import "./js/theme.js";
if ( document.querySelector('.home, .section-content-404, .page-about, .hero-etude') ) {
    import("./js/webgl.js");
}